module.exports = __webpack_public_path__ + "static/media/47.fd30fd24.jpg";